import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-forbidden-page',
  templateUrl: './forbidden-page.component.html',
  styleUrls: ['./forbidden-page.component.css']
})
export class ForbiddenPageComponent implements OnInit {

  @Input('forbidden_msg') forbidden_msg:string =''

  constructor() { }

  ngOnInit() {
  }

}
